import * as React from 'react'
import Link from 'antd/es/typography/Link'
import s from './index.module.scss'

export default function Footer() {
    return (
        <footer className={s.footer}>
            <p>
                Powered by <Link href={'http://giftyon.com'}>Giftyon</Link>
            </p>
        </footer>
    )
}
